export default __webpack_public_path__ + "static/media/css3.53d5eb3c.png";